import {useEffect, useState} from 'react'
import {useEmpreendimentos} from '../../../context/useEmpreendimentos'
import {removeLaunchFiles, updateLaunchFiles} from '../../../../../../../services/urbit-gis'
import {MdClear} from 'react-icons/md'
import {AiOutlineCheckCircle} from 'react-icons/ai'
import {ClearText} from '../../../../../../pages/explorer/components/common'
import {BiTrash} from 'react-icons/bi'
import Swal from 'sweetalert2'

interface ImageType {
  dataURL: string
  type: string
  name: string
  origem: string
  index: number
}

export function DocumentsCard() {
  const {launch, fetchLaunchByID} = useEmpreendimentos()

  const [filesList, setFilesList] = useState<ImageType[]>([])
  const [files, setFiles] = useState<File[]>([])

  const [filesUpload, setFilesUpload] = useState<[]>([])

  useEffect(() => {
    if (launch && (launch.files || launch.files_urbit) && typeof launch.files === 'object') {
      let imageArray = []

      if (launch.files) {
        imageArray = Object.keys(launch.files).map((key, index) => ({
          dataURL: launch.files[key],
          type: key.substring(key.indexOf('.') + 1, key.length),
          name: key, // ou como você precisa mapear os valores
          origem: 'Órulo',
          index: index,
        }))
      }
      let imageArrayUrbit = []
      if (launch.files_urbit) {
        imageArrayUrbit = Object.keys(launch.files_urbit).map((key, index) => ({
          dataURL: launch.files_urbit[key],
          type: key.substring(key.indexOf('.') + 1, key.length),
          name: key, // ou como você precisa mapear os valores
          origem: 'Urbit',
          index: index,
        }))

        setFilesList([...imageArray, ...imageArrayUrbit])
      }
    } else {
      setFilesList([])
    }
  }, [launch])

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files

    if (selectedFiles && selectedFiles.length > 0) {
      const newFiles: File[] = Array.from(selectedFiles) as File[]
      setFiles((prevFiles) => [...prevFiles, ...newFiles])
    }
  }
  async function onSave() {
    const formData = new FormData()

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i], ClearText(files[i]['name'])) // 'files[]' is a common convention for arrays on the server-side
    }

    // if (files) {
    //   files.forEach((item, index) => {
    //     // Convert base64 to Blob
    //     const arr = item.dataURL.split(',')
    //     const mime = arr[0].match(/:(.*?);/)?.[1] || ''
    //     const bstr = atob(arr[1])
    //     let n = bstr.length
    //     const u8arr = new Uint8Array(n)
    //     while (n--) {
    //       u8arr[n] = bstr.charCodeAt(n)
    //     }
    //     const blob = new Blob([u8arr], {type: mime})
    //     formData.append('files', blob, item.name)
    //   })
    // }
    const response = await updateLaunchFiles(launch.id, formData)

    if (response) {
      fetchLaunchByID(launch.id)
      setFiles([])
    }
  }
  const handleRemoveFile = (index: number) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index))
  }

  const handleDrop = (event) => {
    event.preventDefault()
    const droppedFiles = event.dataTransfer.files
    if (droppedFiles.length > 0) {
      const newFiles: File[] = Array.from(droppedFiles) as File[]
      setFiles((prevFiles) => [...prevFiles, ...newFiles])
    }
  }
  const removerArquivo = async (fileIndex) => {
    const response = await removeLaunchFiles(launch.id, fileIndex)
    if (response.status === 200) {
      fetchLaunchByID(launch.id)
    } else {
      Swal.fire('Erro', 'Erro ao Excluir a imagem', 'error')
    }
  }

  return (
    <div className='card flex-grow-1 mb-5 mb-xl-8'>
      <div className='card-header border-0 pt-5'>
        <h2 className='fw-bolder pt-4 px-8 m-0  flex-fill'>Arquivos</h2>
        {/* <SingleFileUploader onFilesSelected={setFilesUpload} width={300} height={100} /> */}

        <input
          type='file'
          hidden
          id='browse'
          onChange={handleFileChange}
          accept='.pdf,.docx,.pptx,.txt,.xlsx'
          multiple
        />
        <label htmlFor='browse' className='btn btn-primary browse-btn me-3'>
          Procurar Arquivos
        </label>
        <button className='btn btn-sm btn-success' type='button' onClick={onSave}>
          Salvar
        </button>
      </div>
      <div className='card-body py-3'></div>
      <div className='row px-6'>
        <div
          className='form-group col-md-12 form-line '
          onDrop={handleDrop}
          onDragOver={(event) => event.preventDefault()}
        >
          <div className='row g-6 g-xl-9 mb-6 mb-xl-9'>
            {filesList.map((fileItem, index) => {
              return (
                <>
                  <div className='col-3 col-sm-3 '>
                    <div className='card h-100'>
                      <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                        <a
                          href={fileItem.dataURL}
                          className='text-gray-800 text-hover-primary d-flex flex-column'
                          target='_blank'
                          rel='noreferrer'
                        >
                          <div className='symbol symbol-75px mb-6'>
                            <img src='/media/svg/files/pdf.svg' alt='' />
                          </div>
                          <div
                            className='fs-5 fw-bolder mb-2 description-limit-caracter'
                            title={fileItem.name}
                          >
                            {fileItem.name}
                          </div>
                        </a>
                        <div className='d-flex justify-content-between align-items-center fs-3'>
                          <b>{fileItem.origem}</b>
                          {fileItem.origem === 'Urbit' ? (
                            <button
                              className='btn btn-icon'
                              type='button'
                              onClick={() => removerArquivo(fileItem.index)}
                            >
                              <BiTrash className='fs-1'></BiTrash>
                            </button>
                          ) : (
                            <></>
                          )}
                        </div>

                        {/* <div className='fs-7 fw-bold text-gray-500 mt-auto'>7 files</div> */}
                      </div>
                    </div>
                  </div>
                </>
              )
            })}

            {files.length > 0 && (
              // <div className='file-list'>
              //   <div className='file-list__container'>
              <>
                {files.map((file, index) => (
                  // <div className='file-item' key={index}>
                  <>
                    <div className='col-3 col-sm-3 '>
                      <div className='card h-100'>
                        <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                          <div className='symbol symbol-75px mb-6'>
                            <img src='/media/svg/files/pdf.svg' alt='' />
                          </div>
                          <div className='fs-5 fw-bolder mb-2'>{file.name}</div>

                          {/* <div className='fs-7 fw-bold text-gray-500 mt-auto'>7 files</div> */}
                        </div>
                        <div className='file-actions card-body d-flex justify-content-center text-center flex-column p-8'>
                          <button
                            className='btn btn-info margin-0-auto'
                            onClick={() => handleRemoveFile(index)}
                          >
                            <MdClear /> Remover
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* <div className='file-info'>
                            <p>{file.name}</p>
                            
                          </div> */}
                  </>
                  // </div>
                ))}
              </> //   </div>
              // </div>
            )}

            {files.length > 0 && (
              <div className='success-file'>
                <AiOutlineCheckCircle style={{color: '#6DC24B', marginRight: 1}} />
                <p>{files.length} file(s) selected</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
